import React, { useContext } from 'react'
import { courseStore } from '../../state/courseStore'
import { StyledVideoContainer, StyledVideo } from './Video.styled'
const Video = ({ videoSrc }) => {
  const { state: courseState } = useContext(
    courseStore
  )

  const onVideoEnded = event => {
    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    }
    if (document.webkitFullscreenElement) {
      if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    }
  }

  return (
    <>
      {videoSrc && (
        <StyledVideoContainer>
          <StyledVideo
            id='video'
            controls
            playsInline
            disablePictureInPicture
            onEnded={onVideoEnded}
            poster={'video/poster/' + videoSrc + '.jpg'}
          >
            <source
              src={'video/mp4/' + videoSrc + '.mp4'}
              type='video/mp4'
            />
            <track
              default
              kind='subtitles'
              label={courseState.language === 'nb-NO' ? 'Bokmål' : 'Nynorsk'}
              srcLang={courseState.language}
              src={
                'video/vtt/' +
                  courseState.language +
                  '/' +
                  videoSrc +
              '.vtt'
              }
            />
          </StyledVideo>
        </StyledVideoContainer>

      )}
    </>
  )
}

export default Video
